import {
  STORE_CASE_INFO,
  TOGGLE_PROCESS_CASE_LOADER,
  TOGGLE_ASSESSMENT_REPORT_MODAL,
  STORE_ASSESSMENT_REPORT,
  CLEAR_CASE_DATA,
  SET_ASSESSMENT_NAME,
} from 'redux/actions/actionTypes';
const initialState = {
  caseId: '',
  caseDetails: {},
  chatRoomId: '',
  showProcessCaseLoader: false,
  showAssessmentReportModal: false,
  assessmentReport: {},
  assessmentName: '',
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case STORE_CASE_INFO: {
      const { caseId, caseDetails = {}, chatRoomId = '' } = payload;
      return { ...state, caseId: caseId, chatRoomId: chatRoomId, caseDetails: caseDetails };
    }
    case TOGGLE_PROCESS_CASE_LOADER: {
      return { ...state, showProcessCaseLoader: payload };
    }
    case TOGGLE_ASSESSMENT_REPORT_MODAL: {
      return {
        ...state,
        showAssessmentReportModal: payload,
      };
    }
    case STORE_ASSESSMENT_REPORT: {
      return {
        ...state,
        assessmentReport: payload.assessmentReport,
      };
    }
    case CLEAR_CASE_DATA: {
      return {
        ...initialState,
      };
    }
    case SET_ASSESSMENT_NAME: {
      return {
        ...state,
        assessmentName: payload,
      };
    }
    default:
      return state;
  }
};
